export const isMacOS = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf("mac") !== -1;
